import styled from "styled-components";

const Chip = styled.button<{ $selected: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 11px;
  border-radius: 8px;
  border: 1px solid
    ${(props) =>
      props.$selected ? props.theme.colors.primary : props.theme.border};
  background: ${(props) =>
    props.$selected ? props.theme.colors.primarySoft : "transparent"};
  color: ${(props) =>
    props.$selected ? props.theme.textColor : props.theme.secondaryTextColor};
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    color: ${(props) => props.theme.textColor};
    border-color: ${(props) =>
      props.$selected ? props.theme.colors.primary : props.theme.borderStrong};
  }
`;

// Toggleable filter. Same semantics as a checkbox, a lot less chrome.
const FilterChip: React.FC<{
  label: React.ReactNode;
  selected: boolean;
  onChange: (selected: boolean) => void;
  title?: string;
}> = ({ label, selected, onChange, title }) => {
  return (
    <Chip
      type="button"
      role="checkbox"
      aria-checked={selected}
      title={title}
      $selected={selected}
      onClick={() => onChange(!selected)}
    >
      {label}
    </Chip>
  );
};
export default FilterChip;
